import { render, staticRenderFns } from "./HeroErrorMessage.vue?vue&type=template&id=7a4ef7b2"
import script from "./HeroErrorMessage.vue?vue&type=script&lang=js"
export * from "./HeroErrorMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports